export interface SignupLookupI {
  region: string;
  gymName: string;
}
export interface SignupUserSearchI {
  emailAddress: any;
  email?: string;
  phoneNumber?: string;
}
